export const P = {
  LESSON_VIEW: 'lesson.view',
  LESSON_EDIT: 'lesson.edit',
  LESSON_START: 'lesson.start',
  CALL_JOIN: 'call.join',
  CALL_SCREEN_SHARE: 'call.screen_share',
  CALL_TRANSFER_CONTROL: 'call.transfer_control',
  STUDENT_VIEW: 'student.view',
  STUDENT_EDIT: 'student.edit',
  COURSE_VIEW: 'course.view',
  USERS_MANAGE: 'users.manage',

  WEB_PROFILE_VIEW: 'web.profile.view',
  WEB_DIALOGS_VIEW: 'web.dialogs.view',

  PLATFORM_PROFILE_VIEW: 'platform.profile.view',
  PLATFORM_DIALOGS_VIEW: 'platform.dialogs.view',
  PLATFORM_COURSES_VIEW: 'platform.courses.view',
  PLATFORM_VIDEO_COURSES_VIEW: 'platform.video_courses.view',
  PLATFORM_STUDENTS_BOARD_VIEW: 'platform.students_board.view',
  PLATFORM_STUDENTS_LIST_VIEW: 'platform.students_list.view',

  ADMIN_PROFILE_VIEW: 'admin.profile.view',
  ADMIN_DIALOGS_VIEW: 'admin.dialogs.view',
  ADMIN_PANEL_VIEW: 'admin.panel.view',
} as const;

export type Permission = (typeof P)[keyof typeof P];
